import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter029() {
  return <KbChapterPage slug="chapter-029" />;
}

(Chapter029 as unknown as { path: string }).path = "/theory-album/029";
